import React, { useEffect, useState } from "react";
import { Accordion, Form, Button } from "react-bootstrap";
import Select from "./Select";

const AcordionItems = ({
    inputs,
    submit,
    getChange,
    errorMessage,
    saveInput,
    requiredInput,
    dataSelect,
    setDataSelect,
    replyTo,
}) => {
    return (
        <>
            {inputs.map((item) => {
                return (
                    <Accordion.Item eventKey={item.id} key={item.id}>
                        <Accordion.Header className="accordion-name">
                            {item.tittle}
                        </Accordion.Header>
                        <Accordion.Body>
                            <form onSubmit={submit}>
                                <Form.Group
                                    className="mb-3"
                                    controlId="exampleForm.ControlTextarea1"
                                >
                                    <Form.Label>Label</Form.Label>
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        name="label"
                                        onChange={getChange}
                                    />
                                </Form.Group>

                                <Form.Group
                                    className="mb-3"
                                    controlId="exampleForm.ControlTextarea1"
                                >
                                    <Form.Label>Placeholder</Form.Label>
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        name="placeholder"
                                        onChange={getChange}
                                    />
                                </Form.Group>

                                <Form.Group
                                    className="mb-3"
                                    controlId="exampleForm.ControlTextarea1"
                                >
                                    <Form.Check
                                        inline
                                        aria-label="option 1"
                                        label="Required"
                                        name="required"
                                        onChange={getChange}
                                    />
                                    {requiredInput === 1 && (
                                        <Form.Check
                                            inline
                                            aria-label="option 1"
                                            label="Error Message"
                                            name="error"
                                            onChange={getChange}
                                        />
                                    )}
                                </Form.Group>

                                {item.name == "mail" && (
                                    <Form.Group
                                        className="mb-3"
                                        controlId="exampleForm.ControlTextarea1"
                                    >
                                        <Form.Check
                                            disabled={
                                                replyTo == 0 ? false : true
                                            }
                                            inline
                                            type="checkbox"
                                            aria-label="option 5"
                                            label="Responder a este correo"
                                            name="reply_to"
                                            onClick={getChange}
                                        />
                                    </Form.Group>
                                )}

                                {errorMessage === 1 && (
                                    <Form.Group
                                        className="mb-3"
                                        controlId="exampleForm.ControlTextarea1"
                                    >
                                        <Form.Label>Message error</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            type="text"
                                            name="error_message"
                                            onChange={getChange}
                                        />
                                    </Form.Group>
                                )}

                                <Form.Group className="mb-3">
                                    <Form.Label>Field size</Form.Label>
                                    <Form.Select
                                        name="size"
                                        onChange={getChange}
                                    >
                                        <option value={0}>Medium</option>
                                        <option value={1}>Complete</option>
                                    </Form.Select>
                                </Form.Group>

                                {item.name == "select" && (
                                    <Select
                                        dataSelect={dataSelect}
                                        setDataSelect={setDataSelect}
                                    />
                                )}

                                <div className="d-grid gap-2 mt-3">
                                    <Button
                                        type="submit"
                                        onClick={() => {
                                            saveInput(item);
                                        }}
                                        variant="primary"
                                        size="sm"
                                    >
                                        Agregar {item.name}
                                    </Button>
                                </div>
                            </form>
                        </Accordion.Body>
                    </Accordion.Item>
                );
            })}
        </>
    );
};

export default AcordionItems;
